import { render, staticRenderFns } from "./AIToolBadge.vue?vue&type=template&id=8b0c9240&scoped=true&"
import script from "./AIToolBadge.vue?vue&type=script&lang=js&"
export * from "./AIToolBadge.vue?vue&type=script&lang=js&"
import style0 from "./AIToolBadge.vue?vue&type=style&index=0&id=8b0c9240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0c9240",
  null
  
)

export default component.exports